import { useState, useEffect } from 'react';
import moment from 'moment';
import { BackendDateFormat } from 'utils/constants';
import { useStore } from 'store/StoreProvider';

function useGetParsedDateTime(dateStr: string | null) {
  const [formattedDate, setFormattedDate] = useState<moment.Moment | null | any>();
  const store=useStore()
  const data=store.getData()

  useEffect(() => {
    if (dateStr) {
      const parsedDate = moment.parseZone(dateStr, BackendDateFormat);
      setFormattedDate(parsedDate);
    } else {
      setFormattedDate(moment.parseZone(data?.start_datetime, BackendDateFormat)); // Handle null input
    }
  }, [dateStr]);

  return formattedDate;
}

export default useGetParsedDateTime;
